'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002emath$002e$002dBig$002dInt from "./scala.math.-Big-Int.js";
var $p;
/** @constructor */
function $c_Lsamples_Persons$package$$anon$7$$anon$11(evaluator$23) {
  this.LI = null;
  this.LI = evaluator$23;
}
export { $c_Lsamples_Persons$package$$anon$7$$anon$11 as $c_Lsamples_Persons$package$$anon$7$$anon$11 };
$p = $c_Lsamples_Persons$package$$anon$7$$anon$11.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Persons$package$$anon$7$$anon$11;
/** @constructor */
function $h_Lsamples_Persons$package$$anon$7$$anon$11() {
}
export { $h_Lsamples_Persons$package$$anon$7$$anon$11 as $h_Lsamples_Persons$package$$anon$7$$anon$11 };
$h_Lsamples_Persons$package$$anon$7$$anon$11.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.LI.h();
  return ((v instanceof $j_scala$002emath$002e$002dBig$002dInt.$c_s_math_BigInt) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_Persons$package$$anon$7$$anon$11 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Persons$package$$anon$7$$anon$11, "samples.Persons$package$$anon$7$$anon$11", ({
  pZ: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Persons$package$$anon$7$$anon$11 as $d_Lsamples_Persons$package$$anon$7$$anon$11 };
